import { Form } from "../../../core/entities/form";
import { formatDateDDMMYY } from "../../../core/functions/DateFormatUtility";
import Tooltip from "../tooltip-icon/Tooltip";
import { InternalStatusCodes } from "../../../core/entities/formEvent";
import { ReactComponent as Error } from "../../../resources/icons/error-circle-cross.svg";

interface Props {
    form: Form;
}

export function FormInfo({ form }: Props) {
    const date = formatDateDDMMYY(form.createdAt);

    let errorToolTipTitle;
    let errorToolTipDescription;
    let errorLable;
    let errorValue;
    if (!!form.currentErrorCode) {
        errorLable = "Fejl";
        errorToolTipTitle = form.currentErrorCodeHeader;
        errorValue = form.currentErrorCodeHeader;
        errorToolTipDescription = form.currentErrorDescription;
    } else if (InternalStatusCodes.DeclinedByDoctor) {
        errorLable = "Lægens afvisningsgrund";
        errorValue = form.currentErrorCodeHeader;
        errorToolTipTitle = form.currentStatusDescription;
        errorToolTipDescription = form.currentErrorCodeHeader;
    }

    return (
        <>
            <table className="table-fixed min-w-[460px] w-full text-left text-sx font-normal">
                <tbody className={"table-body-info"}>
                    <tr>
                        <td>Oprettet</td>
                        <td>{date}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{form.currentStatusDescription ?? <>&mdash;</>}</td>
                    </tr>
                    {(form.currentStatusCode ===
                        InternalStatusCodes.DeclinedByDoctor ||
                        !!form.currentErrorCode) && (
                        <tr>
                            <td>
                                <span>{errorLable}</span>
                            </td>
                            <td>
                                <Tooltip
                                    title={errorToolTipTitle}
                                    description={errorToolTipDescription}
                                >
                                    <div className="flex flex-row space-x-8">
                                        <Error
                                            fill={"#F9DCDC"}
                                            height={20}
                                            width={20}
                                            className={"scale-90"}
                                        />
                                        <span className="text-status-error pr-4">
                                            {errorValue}
                                        </span>
                                    </div>
                                </Tooltip>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}
